import { Link } from '@ipfabric/ui-components/Link/Link';
import {
  type TableColumnFormatSecurity,
  getValueFromKeyOfType,
} from '@ipfabric/utils';
import type { RenderedTableCell } from 'components/Table/cells/RenderedTableCell';
import type { RenderCellContentArguments } from '../model/TableCellContentRenderFunction';

export const renderSecurityCell = <TRow,>(
  format: TableColumnFormatSecurity<TRow>,
  { row, context, severity }: RenderCellContentArguments<TRow>,
): RenderedTableCell => {
  const value = getValueFromKeyOfType(row, format.field);
  const hostSn = getValueFromKeyOfType(row, format.hostSnField);
  const highlightedRuleIndex = format.highlightedRuleIndexField
    ? getValueFromKeyOfType(row, format.highlightedRuleIndexField)
    : undefined;
  const ruleName = getValueFromKeyOfType(row, format.ruleNameField);

  const content =
    !hostSn ||
    hostSn === 'unknown' ||
    !ruleName ||
    !context.onSecurityClick ||
    context.disableLinks ||
    !value ? (
      value
    ) : (
      <Link
        renderAs='button'
        accent={severity === null ? 'positive' : 'contrast'}
        onClick={() => {
          context.onSecurityClick!(
            hostSn,
            ruleName,
            format.securityType,
            highlightedRuleIndex,
          );
        }}
      >
        {value}
      </Link>
    );

  return {
    content,
  };
};
